/**
 * 提供基础API
 * 【注意】：接口写法均为异步写法，但实际执行是分为真异步以及假异步。
 * 其中涉及网络请求的接口，均为真异步，并且callback写在args内。
 * 接口名称前缀为async，均为真异步
 * 其余为假异步，即同步执行
 */

define(['apiUtil', 'base64'], function(apiUtil, base64) {
  let { executeApi, asyncExecuteApi, isWpsEnv } = apiUtil;

  return {
    isWpsEnv,

    executeInTestEnv(callback) {
      if (!isWpsEnv()) {
        callback();
      }
    },

    /**
     * 关闭当前窗口
     */
    closeWindow() {
      executeApi('closeWindow');
    },

    /**
     * 在浏览器中打开网页
     * @param url 地址
     * @param autoLogin 是否自动登录wps账号
     */
    openUrl(url, autoLogin) {
      autoLogin = autoLogin || false;
      executeApi(autoLogin ? 'qingOpenVipAutoLoginUrl' : 'navigateOnNewWindow', { url });
    },

    /**
     * 设置可拖动区域 (标题栏)
     * @remark 非重新设置，已设置拖动区域不去除
     */
    setDragArea(left, top, width, height) {
      executeApi('setDragArea', { left, top, width, height });
    },

    /**
     * 获取父窗口传递到当前窗口的数据
     * @param {string} key
     * @return {Promise<object>}
     */
    getWebViewProperty(key) {
      return asyncExecuteApi('getWebViewProperty', { key });
    },

    /**
     * 设置回传给父窗口的数据
     * @param {string} key
     * @param {object} value = { k: v, ... }
     */
    setWebViewProperty(key, value) {
      executeApi('setWebViewProperty', { key, value });
    },

    /**
     * 设置当前窗口返回给父窗口的结果
     * @param {object} value = { k: v, ... }
     */
    setWindowResult(value) {
      return this.setWebViewProperty('windowResult', value);
    },

    /**
     * 获取子窗口返回给父窗口的结果
     * @return {Promise<object>} = { k: v, ... }
     */
    getWindowResult() {
      return this.getWebViewProperty('windowResult');
    },

    /**
     * HTTP的GET方法请求
     * @param {object} params = { url: 地址, timeout: 超时时间, callback: 回调函数 }
     * @param {object} header
     */
    httpGet(params, header) {
      try {
        executeApi('httpGet', {
          callback: params.callback,
          url: params.url,
          timeout: params.timeout,
          cookie: params.cookie,
          header
        });
      } catch (e) {
        alert(e);
      }
    },

    /**
     * HTTP的POST方法请求
     * @param {object} params = { url: 地址, timeout: 超时时间, data: 传输数据, callback: 回调函数 }
     * @param {object} header
     */
    httpPost(params, header) {
      executeApi('httpPost', {
        callback: params.callback,
        url: params.url,
        timeout: params.timeout,
        cookie: params.cookie,
        data: params.data,
        bRawData: params.bRawData,
        header
      });
    },

    /**
     * 设置全局回调函数
     */
    setWindowCallBack(methodName, cb) {
      window[methodName] = (result) => {
        if (result) {
          result = JSON.parse(base64.decode(result));
          cb(result);
        } else {
          cb();
        }
      };
    },

    returnPaymentResult(callbackName, params) {
      executeApi('returnPaymentResult', {
        callbackHost: callbackName,
        callbackHostArgs: JSON.stringify(params)
      });
    }
  };
});



/** WEBPACK FOOTER **
 ** ./src/modules/unipay/scripts/apiv2/baseApi.js
 **/